import React from 'react';

function InvoiceMethods() {
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card stretch stretch-full">
                    <div className="card-header">
                        <h5 className="card-title">روش های تسویه</h5>
                    </div>
                    <div className="card-body custom-card-action p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                <tr className="border-b">
                                    <th className="text-center">کد</th>
                                    <th className="text-center">عنوان روش</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="text-center">1</td>
                                    <td className="text-center">نقدی</td>
                                </tr>
                                <tr>
                                    <td className="text-center">2</td>
                                    <td className="text-center">نسیه</td>
                                </tr>
                                <tr>
                                    <td className="text-center">3</td>
                                    <td className="text-center">نقدی / نسیه</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InvoiceMethods;